import { NgModule } from "@angular/core";
import { Routes } from "@angular/router";

export const routes: Routes = [
  { path: "", redirectTo: "home", pathMatch: "full" },
  {
    path: "home",
    loadComponent: () =>
      import("./home/home.page").then((m) => m.HomePage),
  },
  {
    path: "profile",
    loadComponent: () =>
      import("./pages/profile/profile.page").then((m) => m.ProfilePage),
  },
  {
    path: "login",
    loadComponent: () =>
      import("./login/login.page").then((m) => m.LoginPage),
  },
  {
    path: "logout",
    loadComponent: () =>
      import("./login/login.page").then((m) => m.LoginPage),
  },
  {
    path: "list-purchase-orders",
    loadComponent: () =>
      import(
        "./orders/purchase/list-purchase-orders/list-purchase-orders.page"
      ).then((m) => m.ListPurchaseOrdersPage),
  },
  {
    path: "view-purchase-order",
    loadComponent: () =>
      import(
        "./orders/purchase/view-purchase-order/view-purchase-order.page"
      ).then((m) => m.ViewPurchaseOrderPage),
  },
  {
    path: "receive-purchase-order/:purchaseOrderId",
    loadComponent: () =>
      import(
        "./orders/purchase/receive-purchase-order/receive-purchase-order.page"
      ).then((m) => m.ReceivePurchaseOrderPage),
  },
  {
    path: "receive-purchase-order-modal",
    loadComponent: () =>
      import(
        "./orders/purchase/receive-purchase-order-modal/receive-purchase-order-modal.page"
      ).then((m) => m.ReceivePurchaseOrderModalPage),
  },
  {
    path: "profile",
    loadComponent: () =>
      import("./pages/profile/profile.page").then((m) => m.ProfilePage),
  },
  {
    path: "list-sales-orders",
    loadComponent: () =>
      import("./orders/sales/list-sales-orders/list-sales-orders.page").then(
        (m) => m.ListSalesOrdersPage
      ),
  },
  {
    path: "view-sales-order",
    loadComponent: () =>
      import("./orders/sales/view-sales-order/view-sales-order.page").then(
        (m) => m.ViewSalesOrderPage
      ),
  },
  {
    path: "ship-sales-order/:salesOrderId",
    loadComponent: () =>
      import("./orders/sales/ship-sales-order/ship-sales-order.page").then(
        (m) => m.ShipSalesOrderPage
      ),
  },
  {
    path: "ship-sales-order-modal",
    loadComponent: () =>
      import(
        "./orders/sales/ship-sales-order-modal/ship-sales-order-modal.page"
      ).then((m) => m.ShipSalesOrderModalPage),
  },
  {
    path: "profile",
    loadComponent: () =>
      import("./pages/profile/profile.page").then((m) => m.ProfilePage),
  },
  {
    path: "production-orders",
    loadComponent: () =>
      import("./production/production-orders/production-orders.page").then(
        (m) => m.ProductionOrdersPage
      ),
  },
  {
    path: "production-order-details/:id",
    loadComponent: () =>
      import(
        "./production/production-order-detail/production-order-detail.page"
      ).then((m) => m.ProductionOrderDetailPage),
  },
  {
    path: "production-order-picking/:id",
    loadComponent: () =>
      import(
        "./production/production-order-picking/production-order-picking.page"
      ).then((m) => m.ProductionOrderPickingPage),
  },
  {
    path: "finish-production-order/:id",
    loadComponent: () =>
      import(
        "./production/finish-production-order/finish-production-order.page"
      ).then((m) => m.FinishProductionOrderPage),
  },
  {
    path: "stock",
    loadComponent: () =>
      import("./stock/stock.component").then((m) => m.StockComponent),
  },
  {
    path: "info",
    loadComponent: () =>
      import("./info/info.page").then((m) => m.InfoPage),
  },
  {
    path: "stock-transfer",
    loadComponent: () =>
      import("./stock/stock-transfer/stock-transfer.page").then(
        (m) => m.StockTransferPage
      ),
  },
  {
    path: "stock-take-details/:id",
    loadComponent: () =>
      import("./stock/stock-take-details/stock-take-details.page").then(
        (m) => m.StockTakeDetailsPage
      ),
  },
  {
    path: "stock-take-product/:id",
    loadComponent: () =>
      import("./stock/stock-take-product/stock-take-product.page").then(
        (m) => m.StockTakeProductPage
      ),
  },
  {
    path: "stock-take-position",
    loadComponent: () =>
      import("./stock/stock-take-position/stock-take-position.page").then(
        (m) => m.StockTakePositionPage
      ),
  },
  {
    path: "survey",
    loadComponent: () =>
      import("./survey/survey.page").then((m) => m.SurveyPage),
  },
  {
    path: "survey/:answerId",
    loadComponent: () =>
      import("./survey/survey.page").then((m) => m.SurveyPage),
  },
  {
    path: "survey-answer-list/:surveyId",
    loadComponent: () =>
      import("./survey-answer-list/survey-answer-list.page").then(
        (m) => m.SurveyAnswerListPage
      ),
  },
  {
    path: "daily-control-points",
    loadComponent: () =>
      import(
        "./control-points/daily-control-points/daily-control-points.page"
      ).then((m) => m.DailyControlPointsPage),
  },
  {
    path: "control-point-modal",
    loadComponent: () =>
      import(
        "./control-points/control-point-modal/control-point-modal.page"
      ).then((m) => m.ControlPointModalPage),
  },
  {
    path: 'haccp-deviation',
    loadComponent: () => import('./control-points/haccp-deviation/haccp-deviation.page').then( m => m.HaccpDeviationPage)
  },

];

// @NgModule({
//   imports: [
//     RouterModule.forRoot(routes, { preloadingStrategy: 'lazy' }),]
// })
// export class AppRoutingModule {}